import { defineStore } from "pinia";
import {
  IContentBlockOptions,
  TopolContentBlockOptionsSchema,
} from "@/schemas/contentBlock/contentBlockScheme";
import { useNotificationsStore } from "./notifications";

interface State {
  contentBlocksOptions?: IContentBlockOptions;
}

export const useContentBlocksOptionsStore = defineStore(
  "contentBlocksOptions",
  {
    state: (): State => ({
      contentBlocksOptions: undefined,
    }),

    actions: {
      setOptions(options: State["contentBlocksOptions"]) {
        const { error, data, success } =
          TopolContentBlockOptionsSchema.safeParse(options);
        if (!success) {
          console.error("Error loading content blocks options", error.issues);
          const notificationsStore = useNotificationsStore();
          notificationsStore.createNotification({
            text: "Error loading content blocks options",
            type: "error",
          });
          return;
        }
        this.contentBlocksOptions = data;
      },
    },
  }
);
